export const HeaderPropsEventType = {
  SignOut: 'sign-out',
};

export default {
  HeaderPropsEventType,
};
